/**
 * @file Add helpers here to access deeply nested or difficult to retrieve store items.
 */

export const getMsisdn = state => state.user.credentials.msisdn;
